<template>
  <v-dialog width="400" v-model="internalDialog" @click:outside="closeDialog">
    <v-card
      style="min-height: 30vh; overflow-y: hidden; padding-bottom: 1.5rem;"
    >
      <v-form>
        <v-card-title class="headline">Delete Sample</v-card-title>
        <v-card-actions style="flex-direction: column;">
          <v-textarea
            v-model="notes"
            label="Notes"
            :rules="rules.required"
            maxlength="255"
          />
          <v-spacer />
          <v-row>
            <v-btn
              color="primary"
              @click="removeSample"
              text
              :disabled="!notes.trim()"
            >
              Confirm Delete
            </v-btn>
            <v-btn color="error" text @click="closeDialog">
              Cancel
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import { mapActions } from "vuex";

export default {
  name: "SampleDeleteDialog",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    sampleId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      notes: "",
      rules: {
        required: [rules.required]
      },
      internalDialog: this.value
    };
  },
  watch: {
    value(val) {
      this.internalDialog = val;
    },
    internalDialog(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    ...mapActions("samples", ["deleteSample"]),
    async removeSample() {
      try {
        const res = await this.deleteSample({
          sample_id: this.sampleId,
          notes: this.notes
        });

        if (res) {
          this.$emit("delete-result", { success: true, response: res });
          this.closeDialog();
        } else {
          this.$emit("delete-result", { success: true, response: true });
        }
      } catch (err) {
        console.error("Delete failed:", err);
        this.$emit("delete-result", { success: false, error: err });
      }
    },
    closeDialog() {
      this.internalDialog = false;
      this.notes = "";
    }
  }
};
</script>
